(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockTarifAuswahlButtons', {
            bindings: {
                bausteinBeitrag: '<abtabBausteinBeitrag',
                changeTarifart: '&?abtabChangeTarifart',
                disabled: '<abtabDisabled',
                options: '<abtabOptions'
            },
            templateUrl: 'bloecke/ergebnis/blockTarifAuswahlButtons.html',
            controller: BlockTarifAuswahlButtonsController,
            controllerAs: 'blockTarifAuswahlButtonsVm'
        });

    BlockTarifAuswahlButtonsController.$inject = [
        'lodash',
        'SchluesselWerteUtilsService',
        'BasisAngebotService'
    ];
    function BlockTarifAuswahlButtonsController(_, SchluesselWerteUtilsService, BasisAngebotService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.getButtonLabel = getButtonLabel;
        vm.isTarifartAktiv = isTarifartAktiv;
        vm.getMainCls = getMainCls;
        vm.getTarifartCls = getTarifartCls;
        vm.getButtonCls = getButtonCls;
        vm.onChangeTarifart = onChangeTarifart;

        function activate() {
            vm.options = vm.options || {};

            vm.gridLayoutCss = vm.options.grid || {};

            vm.tarifartProperty = 'tarifartModellierung';
            vm.moeglicheTarifarten = BasisAngebotService.sortiereTarifarten(_.get(vm.bausteinBeitrag, 'baustein.moeglicheTarifarten', [
                SchluesselWerteUtilsService.create('TARIFART', 'S', 'OPTIMAL')
            ]));

            vm.bausteinTarifart = _.get(vm.bausteinBeitrag, 'baustein.' + vm.tarifartProperty);
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

        function isTarifartAktiv(tarifart, baustein) {
            baustein = baustein || _.get(vm.bausteinBeitrag, 'baustein');

            return (
                _.get(baustein, vm.tarifartProperty + '.wert') === tarifart &&
                _.get(baustein, 'aktiv')
            );
        }

        function getButtonLabel(tarifart) {
            var beitragTarifart = _.get(vm.bausteinBeitrag, 'beitrag.' + tarifart + '.brutto.amount');

            if (!beitragTarifart || _.toNumber(beitragTarifart) === 0) {
                return 'Berechnen';
            }

            return isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein')) ? 'Ausgewählt' : 'Auswählen';
        }

        function getMainCls() {
            var cls = ['row-tarifart-auswahl'];

            if (vm.hasMehrereTarifarten) {
                cls.push('mehrere-tarifarten');
                cls.push('tarifarten-' + _.size(vm.moeglicheTarifarten));
            }

            return cls.join(' ');
        }

        function getTarifartCls(tarifart) {
            var cls = [];

            cls.push('tarifart-' + _.toLower(tarifart));

            if (isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein'))) {
                cls.push('tarifart-aktiv');
            }

            if (_.size(vm.moeglicheTarifarten) === 3) {
                cls.push('small-4 medium-4 large-2');
            }

            if (_.size(vm.moeglicheTarifarten) === 2) {
                cls.push('small-6 medium-6 large-3');
            }

            if (_.size(vm.moeglicheTarifarten) === 1) {
                cls.push('large-6');
            }

            return cls.join(' ');
        }

        function getButtonCls(tarifart) {
            var cls = ['button select round center secondary'];

            if (isTarifartAktiv(tarifart, _.get(vm.bausteinBeitrag, 'baustein'))) {
                cls.push('active');
            }

            if (vm.disabled) {
                cls.push('disabled');
            }

            return cls.join(' ');
        }

        function onChangeTarifart(tarifart, bausteinKey) {
            if (vm.disabled) {
                return;
            }

            vm.bausteinTarifart = tarifart;

            vm.changeTarifart({
                tarifart: tarifart,
                bausteinKey: bausteinKey
            });
        }
    }

})();
